<template>
	<div>
		<div class='knd-swiper' v-if="slides">		
			<swiper
				:slidesPerView="1.2"
				:spaceBetween="30"
				:breakpoints='{
					"640": {
						"spaceBetween": 40,
						"slidesPerView": 1.4
					},
					"950": {
						"spaceBetween": 20,
						"slidesPerView": 2.3
					},

					"1040": {
						"spaceBetween": 60,
						"slidesPerView": 3.3
					}
				}'
				:centeredSlides="false" 
				:grabCursor="true"
				:pagination='{
					"dynamicBullets": true
				}'
				:style="{'--swiper-navigation-color': '#07034A','--swiper-pagination-color': '#07034A'}" 
				@swiper="onSwiper"
				@slideChange="onSlideChange"
				@afterInit="onSlideInit"
				:lazy="true" 
				class='knd-swiper'
			>

			<swiper-slide style="opacity:0;"></swiper-slide>
			<swiper-slide 
				class='knd-article__slide'
				v-for="(slide, index) in slides" 
				:class="{'knd-slide__even': index % 2 === 0}"
				:key="index +'-article'"
				>
				<article class="knd-article">
					<div class='knd-article--image'>
						<picture class="swiper-image__container swiper-lazy" >
							<img :data-src="processWireBase + slide.afbeeldingen[0].url" class="swiper-lazy" />
							<div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div>
						</picture>
					</div>
					
					<div class='knd-article__content knd-article__content_padding'>
						<h4 class='knd-article--title' v-html="getContent(slide.titel)"></h4>

						<div v-html="getContent(slide.beschrijving)"></div>
					</div>
				</article>


			</swiper-slide>
			<swiper-slide style="opacity:0;"></swiper-slide>
		</swiper>

		<div class="knd-swiper-overlay links" @click="nextSlide()">
			<svg class="knd-swiper-pijl links" width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill="#F4FFE7" d="M31.7692 44.0488L31.7692 20L35.2308 20L35.2308 44.0488C36.0615 41.9268 37.4462 40.0642 39.3846 38.461C41.3231 36.8577 43.8615 35.8911 47 35.561L47 39.0976C44.0923 39.4276 41.6 40.5594 39.5231 42.4927C37.4462 44.4732 36.0154 46.6423 35.2308 49L31.7692 49C30.9846 46.6423 29.5538 44.4732 27.4769 42.4927C25.4 40.5593 22.9077 39.4276 20 39.0976L20 35.561C23.1385 35.8911 25.6769 36.8577 27.6154 38.461C29.5538 40.0642 30.9385 41.9268 31.7692 44.0488Z"/>
			</svg>
		</div>
		<div class="knd-swiper-overlay rechts" @click="prevSlide()">
			<svg class="knd-swiper-pijl rechts" width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill="#F4FFE7" d="M31.7692 44.0488L31.7692 20L35.2308 20L35.2308 44.0488C36.0615 41.9268 37.4462 40.0642 39.3846 38.461C41.3231 36.8577 43.8615 35.8911 47 35.561L47 39.0976C44.0923 39.4276 41.6 40.5594 39.5231 42.4927C37.4462 44.4732 36.0154 46.6423 35.2308 49L31.7692 49C30.9846 46.6423 29.5538 44.4732 27.4769 42.4927C25.4 40.5593 22.9077 39.4276 20 39.0976L20 35.561C23.1385 35.8911 25.6769 36.8577 27.6154 38.461C29.5538 40.0642 30.9385 41.9268 31.7692 44.0488Z"/>
			</svg>
		</div>
		</div>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Lazy, Pagination } from 'swiper';

	SwiperCore.use([Pagination, Lazy]);

	import "swiper/swiper-bundle.min.css";
	import 'swiper/components/lazy/lazy.min.css'

	import './swiper.scss';


	export default {
		name: 'Slideswiper',
		props: ['slides', 'lang'],
		components: {
			Swiper,
			SwiperSlide,
		},
		data() {
			return {
				selected: undefined
			};
		},
		mounted: function() {
		},
		methods: {
			onSwiper(swiper) {
				this.swiper = swiper;
				this.swiper.slideTo(2);
			},

			onSlideChange() {},
			onSlideInit() {},

			nextSlide() {
				this.swiper.slidePrev();
			},

			prevSlide() {
				this.swiper.slideNext();
			},

			getContent(content) {
				if (this.lang === "nl") {
					return content.data;
				}
				else {
					return content.data5891;	
				}
			},
		}
	}
</script>